export const inspectTable = [
  {
    id: 1,
    content: '응급상황 발생시 대응체계를 구축하고 있다',
    is_checked: ''
  },
  {
    id: 2,
    content: '응급상황 발생을 관리할 수 있는 조직을 구성하고 그 직무를 규정하고 있다.',
    is_checked: ''
  },
  {
    id: 3,
    content: '응급상황 발생시 연락대응 체계를 구축하고 비상연락망을 유지하고 있다. ',
    is_checked: ''
  },
  {
    id: 4,
    content: '응급상황 발생시 근로자들은 신고체계와 보고체계에 대해 숙지하고 있다. ',
    is_checked: ''
  },
  {
    id: 5,
    content: '응급상황 발생시 대응할 수 있는 소화기, 응급처치함, 구조장비 등 비상 물품을 구비하고 있다. ',
    is_checked: ''
  },
  {
    id: 6,
    content: '응급상황에 대비한 훈련을 정기적으로 실시하고 평가하고 있다.',
    is_checked: ''
  },
  {
    id: 7,
    content: '응급상황이 완료된 후 이를 기록하고 관리하고 있다. ',
    is_checked: ''
  },
]
